import { FormArray, FormControl } from "rectangular-forms";

export class ShoppingCart {
  items: any;
  config: any;

  constructor(config: any) {
    this.config = config;
    this.items = new FormArray([]);
  }

  verifyAlreadyAdded(newItem: any) {
    return this.items.value.some((addedItem: any) => {
      return this.config.verifyAlreadyAdded(newItem, addedItem);
    });
  }

  addItem(item: any) {
    if (this.verifyAlreadyAdded(item)) {
      return null;
    }
    this.items.push(new FormControl(item));
  }

  removeItem(id: any) {
    const index: any = this.items.value.findIndex((addedItem: any) => {
      return this.config.findItemById(addedItem, id);
    });
    index >= 0 && this.items.removeAt(index);
    return index;
  }
}
